import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import heroImg from "./assets/case1.jpg";

const HeroSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#f9fafb] snap-section">

      <div className="max-w-[1200px] mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">

        {/* LEFT */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false }}
        >
          <p className="text-[#FF7A00] font-semibold mb-4">
            Clients & Case Studies
          </p>

          <h1 className="text-5xl md:text-5xl font-bold text-[#111827] leading-tight mb-6">
            Real Impact.
            <br />
            <span className="text-[#FF7A00]">Proven Results.</span>
          </h1>

          <p className="text-gray-600 text-lg mb-8 max-w-lg">
            Discover how Winglo empowers laboratories through automation,
            seamless integration, and real-time insights.
          </p>

          <div className="flex gap-4">

          
            <a href="#case-studies">
              <button className="bg-[#FF7A00] text-white px-8 py-4 rounded-lg font-semibold shadow-md hover:shadow-lg transition">
                View Case Studies
              </button>
            </a>

          
            <Link
              to="/contact#ContactForm"
              className="border border-gray-300 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition"
            >
              Talk to Our Team
            </Link>

          </div>
        </motion.div>

        {/* RIGHT */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false }}
          className="relative"
        >
          <img
            src={heroImg}
            alt="Case Study"
            className="rounded-3xl shadow-2xl"
          />

          <div className="absolute bottom-6 left-6 bg-white rounded-xl px-5 py-3 shadow-lg">
            <p className="text-sm font-semibold text-[#FF7A00]">
              2000+ Devices Integrated
            </p>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default HeroSection;